var AlgoliaAutocomplete = function() {

  function launchSearch(timeout)
  {
    if(!window.instantsearch)
    {
      return setTimeout(launchSearch, 100, timeout - 1);
    }
    else if(timeout <= 0)
    {
      return;
    }
    var search = instantsearch({
      indexName: window.translations.algoliaPageIndex,
      searchClient: algoliasearch(
        window.translations.algoliaId,
        window.translations.algoliaKey
      )
    });

    // Create the render function
    var renderAutocomplete = function(renderOptions, isFirstRender) {
      var indices = renderOptions.indices;
      var currentRefinement = renderOptions.currentRefinement;
      var refine = renderOptions.refine;
      var widgetParams = renderOptions.widgetParams;

      if (isFirstRender) {
        var input = document.querySelector("input.search")
        var results = document.createElement('div');
        results.className = "results";

        widgetParams.container.appendChild(results);

        $(input).parent().find("input").on("input", function(event){
          console.log(event.currentTarget.value);
          refine(event.currentTarget.value);          
        });
      }

      indices = indices.filter(function(index) {
        return index.label != "primary";
      });
 
      if(!currentRefinement)
      {
          widgetParams.container.querySelector('.results').innerHTML = "";
          return; 
      }

      document.querySelector('input.search').value = currentRefinement;
      widgetParams.container.querySelector('.results').innerHTML = indices
        .map(function(result){
          var index = result.index;
          var hits = result.hits;
          var result = '';
          if(index.match(/product/)) {
            hits.slice(0,6).forEach(function(hit) {
              var container = $("<a data-productid='" + hit.objectID + "' rel='nofollow noopener' class='product' href='" + hit.url  + "' data-ref='search'>");
              container.append("<div class='image'><img src='" + hit.image + "'></div>");
              container.append("<div class='title'>" + hit._highlightResult.title.value + "</div>");
              container.append("<div class='price'>" + hit.price + hit.currency + "</div>");
              container.append("<div class='cta'><div class='button'>" + window.translations.ctaText + "</div></div>");
              result += container[0].outerHTML;
            });
          }
          else if(index.match(/page/)) {
            hits.slice(0,6).forEach(function(hit) {
              console.log(hit);
              var container = $("<a class='page' href='" + hit.url  + "'>");

              container.append("<div class='left'></div>");
              container.find(".left").append("<img src='" + hit.image + "'>");

              container.append("<div class='right'></div>");

              container.find(".right").append("<div class='title'>" + hit.title + "</div>");
              /*var content = hit._highlightResult.content.value.slice(0,200);
              if (hit._highlightResult.content.value.match(/(?:\.|^) ?(.{0,100}<mark>[^<]*<\/mark>.{0,100})/i)) {
                content = hit._highlightResult.content.value.match(/(?:\.|^) ?(.{0,100}<mark>[^<]*<\/mark>.{0,100})/i)[1];
              }
              container.append("<div class='content'>" + content + "</div>");*/

              container.find(".right").append("<div class='byline'>" + hit.byline + "</div>");

              result += container[0].outerHTML;
            });
          }

          return "<div class='index-container'>" + result + "</div>";
        })
        .join('');
    };

    // Create the custom widget
    var customAutocomplete = instantsearch.connectors.connectAutocomplete(
      renderAutocomplete
    );

    var autocomplete = customAutocomplete({
      container: document.querySelector('#algolia-container'),
      indices: [
        //{ label: 'Products', value: window.translations.algoliaProductIndex },
        { label: 'Pages', value: window.translations.algoliaPageIndex }
      ]
    });

    if($(".HomePage").length > 0)
    {
      autocomplete = customAutocomplete({
        container: document.querySelector('#algolia-container'),
        indices: [
          { label: 'Pages', value: window.translations.algoliaPageIndex }
          //{ label: 'Products', value: window.translations.algoliaProductIndex }
        ]
      });
    }

    // Instantiate the custom widget
    search.addWidgets([
      autocomplete
    ]);
    
    search.start();
  }

  /*$("input.search").on("input", function(){
    $(this).next().val($(this).val());
  });*/

  var searchStarted = false;
  var algoliaLoaded = false;
  $(".search-icon, input.search").on("click", function(e) {
    e.stopPropagation();

    if(!algoliaLoaded)
    {
        algoliaLoaded = true;
        wait();
    }
    
    function toggleSearch(){
      $("#algolia-container").toggleClass("active");
      $("body").toggleClass("no-scroll");
      if ($("#algolia-container").find("input").val() == "")
      {
        $(".results").html("");
      }
      var input = $("#algolia-container").find("input")[0];
      if(input) input.focus();
    }

    if(!searchStarted) {
      setTimeout(toggleSearch, 50);
    } else {
      toggleSearch();
    }
  });

  if($(".HomePage").length > 0)
  {
      wait();
  }

  $("#algolia-container").on("click", function(e) {
    e.stopPropagation();
  })

  $("#algolia-homepage-container").on("click", function(){
     $(this).find(".results").html("");
     $(this).off().addClass("launched");
  });

  $("body").on("click scroll", function(e){
      $("#algolia-container").removeClass("active");
      $("body").removeClass("no-scroll");
  });

  function wait() {
    if(false && window.location.hostname == "https://www.produktgranskningen.se") {
        return;
    }

    setTimeout(function(){
      var isScript = document.createElement("script");
      isScript.async = true;
      isScript.src = "https://cdn.jsdelivr.net/npm/algoliasearch@3.33.0/dist/algoliasearchLite.min.js";
      document.body.appendChild(isScript);
      var acScript  = document.createElement("script");
      acScript.async = true;
      acScript.src = "https://cdn.jsdelivr.net/npm/instantsearch.js@3.4.0/dist/instantsearch.production.min.js";
      document.body.appendChild(acScript);

      launchSearch(20);
    }, 10);
  }
};

module.exports = AlgoliaAutocomplete;
